// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

// Libraries
import { Observable, takeUntil } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select } from '@ngxs/store';

// Models
import { UserUnitPeriodChannelDto } from '../../modules/channel/models/user-unit-period-channel-dto';
import { JobTypeChannelDto } from '../../modules/job/components/daily-report/models/job-type-channel-dto';
import { Job } from '../../modules/job/models';
import { JobTypeChannelMappingDto } from '../../modules/job/models/job-type-channel-mapping-dto.model';
import { AppCleanup, LookUpResponse } from '../../shared/models';

// Service
import { JobService } from '../../modules/job/services/job.service';

// Store
import { LookupState } from '../../shared/state/lookup.state';

@Component({
	selector: 'job-channel-mapping-edit-dialog',
	templateUrl: './job-channel-mapping-edit-dialog.component.html',
	styleUrls: ['./job-channel-mapping-edit-dialog.component.scss'],
})
export class JobChannelMappingEditDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string = 'Channel override';
	@Select(LookupState.lookups) lookups$: Observable<LookUpResponse>;
	userUnitPeriodChannels: UserUnitPeriodChannelDto[] = [];
	selectedUserUnitPeriodChannel: UserUnitPeriodChannelDto;
	jobTypeChannels: JobTypeChannelDto[] = [];
	selectedJobTypeChannel: JobTypeChannelDto;
	form: FormGroup;

	constructor(
		public dialogRef: MatDialogRef<JobChannelMappingEditDialogComponent>,
		private jobService: JobService,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: { job: Job; jobTypeChannelMapping: JobTypeChannelMappingDto }
	) {
		super();
	}

	ngOnInit() {
		this.userUnitPeriodChannels = this.jobService.findUserUnitPeriodChannelsForJob(this.data.job.key);
		this.selectedUserUnitPeriodChannel = this.userUnitPeriodChannels.find((uupc) => uupc.unitPeriodChannel.channelId === this.data.jobTypeChannelMapping.channelId);

		this.lookups$.pipe(takeUntil(this.destroy)).subscribe((lookups) => {
			if (lookups) {
				this.jobTypeChannels = lookups.jobTypeChannels.filter((jtc) => jtc.jobTypeId === this.data.job.jobTypeId && jtc.allowManualOverride === true);
			}
		});

		this.selectedJobTypeChannel = this.data.jobTypeChannelMapping.jobTypeChannel;
		this.buildForm();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			channelId: [this.selectedUserUnitPeriodChannel?.unitPeriodChannel?.channelId],
			jobTypeChannelId: [this.selectedJobTypeChannel?.id],
		});
	}

	submit() {
		this.dialogRef.close({
			channelId: this.form.controls.channelId.value,
			jobTypeChannelId: this.form.controls.jobTypeChannelId.value,
		});
	}
}
